"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

export const SubscribeFormName = "Footer SubscribeForm";

export const SubscribeFormComponent: RegisteredComponent = {
  name: SubscribeFormName,
  models: [getBuilderModelName("footer")],
  component: dynamic(
    async () =>
      (await import("@jti/ui/eva-components/Footer/components/SubscribeForm"))
        .SubscribeForm
  ),
  inputs: [
    {
      name: "title",
      type: "string",
      defaultValue: "",
    },
    {
      name: "subTitle",
      type: "string",
      defaultValue: "",
    },
    {
      name: "description",
      type: "string",
      defaultValue: "",
    },
    {
      name: "emailInputProps",
      type: "object",
      subFields: [
        {
          name: "placeholder",
          type: "string",
        },
      ],
      defaultValue: {
        placeholder: "Enter your email",
      },
    },
    {
      name: "successMessage",
      type: "object",
      subFields: [
        {
          name: "title",
          type: "string",
        },
        {
          name: "subTitle",
          type: "string",
        },
      ],
      defaultValue: {
        title: "",
        subTitle: "",
      },
    },
  ],
};
